import { IRequestAmbulance, IRequestPersonnel } from 'interfaces/ResourceRequests';

function formatDeclineResources<T extends IRequestAmbulance | IRequestPersonnel>(
  payload: T[],
): T[] {
  return payload.map((v) => ({
    ...v,
    items: v?.items && v.items.map((item) => ({ ...item, accepted: false })),
  }));
}
export default formatDeclineResources;
